/**
 * Admin KYC update field policy.
 *
 * Live unique constraint on kyc_information.id_number_hash is named unique_id_hash.
 * There is no unique_id_hash column. Country-only edits must never rewrite the hash.
 */

export const KYC_ADMIN_UPDATE_ALLOWED = [
  'first_name',
  'last_name',
  'id_type',
  'phone_number',
  'email_address',
  'street_address',
  'city',
  'province',
  'postal_code',
  'country_code',
  'country_name',
  'id_number_encrypted',
  'id_number_hash',
]

export const KYC_ID_DECRYPT_SENTINELS = ['N/A', 'Error decrypting']

export const KYC_UNIQUE_ID_HASH_MESSAGE = 'This ID/Passport number is already registered on another account. Save country and other fields without changing the ID number.'

export function isKycIdDecryptSentinel(value) {
  return typeof value === 'string' && KYC_ID_DECRYPT_SENTINELS.includes(value.trim())
}

export function shouldRewriteKycIdHash(originalId, currentId) {
  const current = typeof currentId === 'string' ? currentId.trim() : ''
  const original = typeof originalId === 'string' ? originalId.trim() : ''
  if (!current || isKycIdDecryptSentinel(current)) return false
  return current !== original
}

export function isUniqueIdHashConstraintError(message) {
  const text = String(message || '')
  if (!text.includes('duplicate key')) return false
  return text.includes('unique_id_hash') || text.includes('id_number_hash')
}

export function sanitizeKycAdminUpdateFields(updateFields) {
  const src = updateFields && typeof updateFields === 'object' ? updateFields : {}
  const fields = {}
  for (const key of KYC_ADMIN_UPDATE_ALLOWED) {
    if (Object.prototype.hasOwnProperty.call(src, key)) fields[key] = src[key]
  }
  delete fields.unique_id_hash

  const isBlank = (value) => value === null || value === undefined || (typeof value === 'string' && value.trim().length === 0)
  const strippedBlankEncrypted = isBlank(fields.id_number_encrypted) || isKycIdDecryptSentinel(fields.id_number_encrypted)
  const strippedBlankHash = isBlank(fields.id_number_hash)
  if (strippedBlankEncrypted) delete fields.id_number_encrypted
  if (strippedBlankHash) delete fields.id_number_hash

  if (typeof fields.country_code === 'string') {
    fields.country_code = fields.country_code.trim().toUpperCase().slice(0, 3)
  }

  return { fields, strippedBlankEncrypted, strippedBlankHash }
}
